
const projectDetails = [
    {
        name: 'Netflix-Clone',
        skill: 'REACT, Firebase',
        desc: 'This is an attempt to clone the Netflix home page with certain UI tweaks and a on Click trailer playing functionality using third party libraries (react-YouTube and movie-trailer).',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/Netflix-clone',
            projectUrl: 'https://netflix-clone-fbc93.web.app/'
        }
    },
    {
        name: 'Step-Form',
        skill: 'REACT',
        desc: 'Its and attempt to create a multi-step Form using React.',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/stepForm',
            projectUrl: 'https://onboarding-step-form.netlify.app/'
        }
    },
    {
        name: 'Admin-UI',
        skill: 'REACT',
        desc: 'An admin dashboard made with React.js with several functionalities using fundamental concepts.',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/admin-ui/tree/master',
            projectUrl: 'https://geek-admin-ui.netlify.app/'
        }
    },
    {
        name: 'Teerex-Store',
        skill: 'REACT',
        desc: 'An attempt to develop an online store for purchasing items with functionalities including search filter, checkbox filter, add to cart feature, Edit cart.',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/teeRex-store',
            projectUrl: 'https://teerex-store.netlify.app/'
        }
    },
    {
        name: 'Onboarding step-form',
        skill: 'REACT',
        desc: 'This is a multiple step-form with state management using Redux. ',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/stepForm',
            projectUrl: 'https://onboarding-step-form.netlify.app/'
        }
    },
    {
        name: 'Universal-Converter',
        skill: 'Android',
        desc: 'Universal Converter will do the math for you. Be it currency conversion, area/volume of different figures or even Loan calculation and many more, you can find all this in a single place.',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/Universal-Converter',
            projectUrl: 'https://play.google.com/store/apps/details?id=my.second.universalconverter'
        }
    },
    {
        name: 'Planet',
        skill: 'Android',
        desc: 'Interested in planetary bodies? Well, you are at the right place to explore about different planets with a high quality image representation and some interesting facts about our neighborhood bodies.',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/Planet',
            projectUrl: 'https://play.google.com/store/apps/details?id=my.first.planet'
        }
    },
    {
        name: 'Doremi',
        skill: 'Node.js',
        desc: 'An application to track the subscription record for different categories(Music, Video, Podcast)',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/doremi',
            projectUrl: null
        }
    },
    {
        name: 'Online-Fitness-and-Nutrition',
        skill: 'Java',
        desc: 'A web application for the users to get a diet and workout plans by giving out some details (weight, height, age, etc) and receive an email from the secure service of google.',
        links: {
            git: 'https://github.com/Shubham-Srivastava11/Online-Fitness-and-Nutrition',
            projectUrl: null
        }
    },

]

export default projectDetails;